import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { forwardRef } from 'react';
import { classNames } from '~/utils/classNames';

type CheckedState = RadixCheckbox.CheckedState;

export interface CheckboxProps extends Omit<RadixCheckbox.CheckboxProps, 'onChange'> {
  onChange?: (checked: CheckedState) => void;
}

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>((props, ref) => {
  const { checked, disabled, className, onChange, ...rest } = props;

  return (
    <RadixCheckbox.Root
      ref={ref}
      checked={checked}
      className={classNames(
        'group',
        'flex items-center justify-center',
        'w-4 h-4 rounded border border-bolt-ds-borderOutline bg-transparent',
        'focus:ring-2 focus:ring-bolt-ds-brandHighlight outline-none',
        '[&[aria-checked="true"]]:bg-bolt-ds-brand [&[aria-checked="mixed"]]:bg-bolt-ds-brand',
        'text-bolt-ds-onBrand',
        '[&[data-disabled]]:op-50 [&[data-disabled]]:cursor-not-allowed',
        className,
      )}
      onCheckedChange={onChange}
      disabled={disabled}
      {...rest}
    >
      <RadixCheckbox.CheckboxIndicator className="flex items-center justify-center">
        {checked === 'indeterminate' && <span className="i-bolt:minus size-3.5" />}
        {checked === true && <span className="i-bolt:check size-3.5" />}
      </RadixCheckbox.CheckboxIndicator>
    </RadixCheckbox.Root>
  );
});
